import React from "react";
import "./EtatBadge.css";

const EtatBadge = ({ etat }) => {
  let color = "";

  switch (etat) {
    case "EN_ATTENTE":
      color = "#f59e0b"; // orange
      break;
    case "EN_COURS":
      color = "#3b82f6"; // bleu
      break;
    case "TERMINE":
      color = "#10b981"; // vert
      break;
    default:
      color = "#9ca3af"; // gris
      break;
  }

  return (
    <span className="etat-badge" style={{ backgroundColor: color }}>
      {etat === "EN_ATTENTE"
        ? "En attente"
        : etat === "EN_COURS"
        ? "En cours"
        : etat === "TERMINE"
        ? "Terminé"
        : etat}
    </span>
  );
};

export default EtatBadge;
